module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('HeaderWrap'), _vm._v(" "), _c('div', {
    staticClass: "container main"
  }, [_c('router-view')], 1), _vm._v(" "), _c('FooterWrap')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-49a0b90e!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 93
// module chunks = 1